import React from "react"
import { Link } from "gatsby"
import classnames from "@utils/classnames"

import styles from "./button.module.scss"

const Button = ({
  to,
  href,
  className,
  children,
  color,
  large = false,
  ...props
}) => {
  const classNames = classnames(styles.btn, className, "box", {
    "box-ghost": !color,
    "box-blue": color === "blue",
    [styles.btnLarge]: large,
  })
  if (to) {
    return (
      <Link to={to} className={classNames} {...props}>
        <div>{children}</div>
      </Link>
    )
  }
  return (
    <a
      tabIndex={0}
      className={classNames}
      role="button"
      {...(href ? { href, target: "_blank" } : null)}
      {...props}
    >
      <div>{children}</div>
    </a>
  )
}

export default Button
